var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessfulEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 79,
    viewBox: "0 0 84 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.084 59.0417H32.9173C25.6673 59.0417 20.834 55.4167 20.834 46.9584V30.0417C20.834 21.5834 25.6673 17.9584 32.9173 17.9584H57.084C64.334 17.9584 69.1673 21.5834 69.1673 30.0417V46.9584C69.1673 55.4167 64.334 59.0417 57.084 59.0417Z",
    stroke: "#8898CA",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0827 31.25L49.5185 37.2917C47.0293 39.2733 42.9452 39.2733 40.456 37.2917L32.916 31.25",
    stroke: "#8898CA",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 60,
    r: 19,
    fill: "#209765"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63477 61.338L16.3249 68.5633L30.508 54.3802",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfulEmail);
export default __webpack_public_path__ + "static/media/successfulEmail.3bef5a88202c63708fd1910694e700df.svg";
export { ForwardRef as ReactComponent };